/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var PortIcon = createIcon({
  name: 'PortIcon',
  height: 1024,
  width: 951,
  svgPath: 'M549.554 64l-164.114 469.806-137.189-243.52h-248.251v114.286h181.463l228.526 405.623 169.6-485.623 120.434 189.714h250.834v-114.286h-188.023z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default PortIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/port-icon.js
// module id = 1210
// module chunks = 0